<script lang="ts">
    import Occasion from "../../application/models/Occasion.ts";
    import Manager from "../../application/models/Manager.ts";
    import ContentLine from "../cardElements/ContentLine.svelte";
    import TypeElement from "../TypeElement.svelte";
    import {_} from 'svelte-i18n';

    export let cardData: Occasion;
    export let manager: Manager;

    let calcTime = manager.dateManager.calculateTimeFromBlockNumber;
</script>

<div class="card p-4">
    {#if cardData.course.subject !== undefined}
        <div class="title">{cardData.course.subject.name}</div>
        <div class="subtitle">{cardData.course.code}</div>
        <div class="card-content">
            <div class="divider is-primary">{$_('cardModal.basic')}</div>
            <ContentLine lead="{$_('cardModal.start')}" text="{calcTime(cardData.startBlock)}"/>
            <ContentLine lead="{$_('cardModal.end')}" text="{calcTime(cardData.endBlock)}"/>
            <ContentLine lead="{$_('cardModal.classroom')}" text="{cardData.classroom}"/>
            <div class="columns">
                <div class="column is-3"><strong>{$_('cardModal.type')}:</strong></div>
                <div class="column"><TypeElement type={cardData.course.type}/></div>
            </div>
            {#if cardData.weeks==="111111111111111"}
                <ContentLine lead="{$_('cardModal.regularity')}" text="{$_('cardModal.allWeek')}"/>
            {/if}
            {#if cardData.weeks!=="111111111111111"}
                <div class="columns">
                    <div class="column is-3">
                        <strong>{$_('cardModal.regularity')}</strong>
                    </div>
                    {#each cardData.weekArray as week}
                        <div class="column is-narrow">{week}.,</div>
                    {/each}
                    <div class="column is-narrow">
                        {$_('cardModal.week')}
                    </div>
                </div>
            {/if}
            <div class="divider is-primary">{$_('cardModal.tutors')}</div>
            {#each cardData.course.tutors as tutor}
                <div class="columns">
                    <div class="column">
                        <ContentLine lead="{$_('cardModal.tutor')}" text={tutor.name}/>
                    </div>
                </div>
            {/each}
            <div class="divider is-primary">{$_('cardModal.timetables')}</div>
            {#each cardData.course.timetables as timetable}
                <ContentLine lead="{$_('cardModal.timetable')}" text={timetable.name}/>
            {/each}
        </div>
    {/if}
</div>